import React, { useState, useEffect } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReviewSection = ({ task, user }) => {
 const [reviews, setReviews] = useState([]);
 const [showReviewForm, setShowReviewForm] = useState(false);
 const [reviewData, setReviewData] = useState({ rating: 5, comment: "" });
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 checkExistingReview();
 }, []);

 const checkExistingReview = async () => {
 try {
 // Check if current user already reviewed this task (targeted запрос по task_id, без загрузки всего списка)
 const revieweeId = task.customer_id === user.id ? task.executor_id : task.customer_id;
 const existingResp = await axios.get(`${API}/users/${revieweeId}/reviews?task_id=${task.id}&limit=1`);
 const existingReview = existingResp.data.items.find(r => r.reviewer_id === user.id);

 if (!existingReview) {
 setShowReviewForm(true);
 }

 const listResp = await axios.get(`${API}/users/${revieweeId}/reviews?limit=3`);
 setReviews(listResp.data.items || []);
 } catch (error) {
 console.error("Error checking reviews:", error);
 } finally {
 setLoading(false);
 }
 };

 const submitReview = async (e) => {
 e.preventDefault();
 try {
 await axios.post(`${API}/tasks/${task.id}/review`, reviewData);
 alert("Отзыв отправлен!");
 setShowReviewForm(false);
 checkExistingReview();
 } catch (error) {
 alert("Ошибка при отправке отзыва");
 }
 };

 const renderStars = (rating) => {
 return Array.from({ length: 5 }, (_, i) => (
 <Star key={i} className={`w-4 h-4 inline ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} />
 ));
 };

 if (loading) {
 return <div className="text-center">Загрузка отзывов...</div>;
 }

 return (
 <div>
 <h3 className="text-lg font-semibold mb-4">Отзывы и рейтинг</h3>
 
 {showReviewForm && (
 <form onSubmit={submitReview} className="mb-6 p-4 bg-gray-50 rounded-lg">
 <h4 className="font-medium mb-3">Оставьте отзыв о {task.customer_id === user.id ? 'исполнителе' : 'заказчике'}</h4>
 
 <div className="mb-4">
 <label className="block text-sm font-medium text-gray-700 mb-2">Рейтинг</label>
 <div className="flex space-x-1">
 {Array.from({ length: 5 }, (_, i) => (
 <button
 key={i}
 type="button"
 onClick={() =>setReviewData({ ...reviewData, rating: i + 1 })}
 className={`text-2xl ${i < reviewData.rating ? 'text-yellow-400' : 'text-gray-300'} hover:text-yellow-400`}
 >
 <Star className={`w-6 h-6 ${i < reviewData.rating ? 'fill-yellow-400' : ''}`} />
 </button>
 ))}
 </div>
 </div>
 
 <div className="mb-4">
 <label className="block text-sm font-medium text-gray-700 mb-2">Комментарий</label>
 <textarea
 value={reviewData.comment}
 onChange={(e) =>setReviewData({ ...reviewData, comment: e.target.value })}
 rows="3"
 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
 placeholder="Расскажите о своем опыте..."
 />
 </div>
 
 <button
 type="submit"
 className="reversia-btn reversia-btn-blue reversia-btn-md"
 >Отправить отзыв
 </button>
 </form>
 )}
 
 {reviews.length > 0 && (
 <div className="space-y-4">
 <h4 className="font-medium">Отзывы:</h4>
 {reviews.slice(0, 3).map((review) => (
 <div key={review.id} className="p-4 bg-gray-50 rounded-lg">
 <div className="flex items-center justify-between mb-2">
 <div className="flex items-center space-x-2">
 <span className="font-medium">{review.reviewer_name}</span>
 <div className="flex">{renderStars(review.rating)}</div>
 </div>
 <span className="text-sm text-gray-500">
 {new Date(review.created_at).toLocaleDateString()}
 </span>
 </div>
 <p className="text-gray-700">{review.comment}</p>
 </div>
 ))}
 </div>
 )}
 </div>
 );
};
